"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = function (e) {
  var t = new Date().getFullYear(),
      r = "";

  if (e && 0 !== Object.keys(e).length || (r = "Copyright © " + t), "string" == typeof e && (r = "Copyright © " + t + " " + e), "object" == typeof e) {
    var o = e.name,
        a = e.startYear;
    r = (e.short ? "" : "Copyright ") + (e.htmlEntities ? "&copy;" : "©") + " " + (a ? a + "-" : "") + (e.endYear || t) + (o ? " " + o : "");
  }

  return r;
};